import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction, STORAGE } from "../_config";
import { CallApi } from "./api/callApi";

export function* loginUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.LOGIN, action.payload, false);
}

export function* loginWithEmail(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.LOGIN, data);
    if (resp.status >= 200 && resp.status < 300 && resp?.data?.data) {
      if (!resp.data.data.requires_2fa) {
        const token = resp.data.data.token;
        const user = resp.data.data.user;
        const rememberMe = data.rememberMe || false;
        if (token && user) {
          // Always store token in localStorage to support multiple tabs
          // This works with redux-persist which uses localStorage by default
          console.log("🔎 [SAGA] BEFORE storing token - postLoginRedirect:", localStorage.getItem("postLoginRedirect"));
          localStorage.setItem(STORAGE, token);
          console.log("🔎 [SAGA] AFTER storing token - postLoginRedirect:", localStorage.getItem("postLoginRedirect"));

          // Handle Remember Me functionality - save email/password preferences
          if (rememberMe) {
            // Save email and rememberMe flag for future logins
            localStorage.setItem("DR-JOBS-REMEMBER-EMAIL", user.email || data.email);
            localStorage.setItem("DR-JOBS-REMEMBER-ME", "true");
          } else {
            // Clear any previously saved credentials
            console.log(
              "🔎 [SAGA] BEFORE clearing remember me - postLoginRedirect:",
              localStorage.getItem("postLoginRedirect")
            );
            localStorage.removeItem("DR-JOBS-REMEMBER-EMAIL");
            localStorage.removeItem("DR-JOBS-REMEMBER-ME");
            console.log(
              "🔎 [SAGA] AFTER clearing remember me - postLoginRedirect:",
              localStorage.getItem("postLoginRedirect")
            );
          }

          // Dispatch Redux action to update authentication state
          yield put({
            type: ACTIONS.USER.LOGIN,
            payload: {
              user: user,
              token: token,
            },
          });

          // Fetch permissions for member users
          if (user.user_type === "member" && user.id) {
            try {
              yield call(getUserPermissionsModule, {
                payload: { userId: user.id },
                callbackSuccess: () => {},
                callbackError: (error: any) => {
                  console.warn("Failed to load user permissions:", error);
                },
              });
            } catch (error) {
              console.warn("Error fetching user permissions:", error);
            }
          }

          // Call success callback
          action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
          action && action.callbackError && action.callbackError("Token or user missing");
        }
      } else {
        action && action.callbackSuccess && action.callbackSuccess(resp.data);
      }
    } else {
      action && action.callbackError && action.callbackError(resp.data);
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* registration(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.REGISTRATION, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      localStorage.setItem(STORAGE, resp.data.token);
      yield put({
        type: ACTIONS.USER.LOGIN,
        payload: {
          user: resp.data.data,
          token: resp.data.token,
        },
      });
      console.log("registter", resp.data);
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* completeProfile(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.COMPLETE_PROFILE, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* forgotPassword(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.FORGOT_PASSWORD, action.payload, false);
}

export function* resetPassword(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.RESET_PASSWORD, action.payload, false);
}

export function* AutoLogin(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.AUTOLOGIN, data);

    // Check if response is successful
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      // Handle both nested (resp.data.data) and direct (resp.data) response structures
      const responseData = resp.data.data || resp.data;
      const token = responseData.token;
      const user = responseData.user;
      const company = responseData.company;
      const userType = responseData.user_type;
      const unreadNotifications = responseData.unread_notifications_count;

      if (token && user) {
        // Store token in localStorage first so it can be used for subsequent API calls
        localStorage.setItem(STORAGE, token);

        // Merge company data into user object if available
        const userWithCompany = company ? { ...user, company } : user;

        // Dispatch Redux action to update authentication state
        yield put({
          type: ACTIONS.USER.LOGIN,
          payload: {
            user: userWithCompany,
            token: token,
          },
        });

        // Fetch user profile data with the new token to get the latest user information
        try {
          const profileResp = yield call(CallApi.GET, API_URL.USER.DETAILS, {}, true);
          if (profileResp.status >= 200 && profileResp.status < 300 && profileResp.data) {
            const profileData = profileResp.data.data || profileResp.data;
            console.log("Profile data fetched successfully in AutoLogin:", profileData);

            // Update user with profile data
            yield put({
              type: ACTIONS.USER.ME,
              payload: profileData,
            });
          }
        } catch (profileError) {
          console.warn("Failed to fetch profile in AutoLogin:", profileError);
          // Continue with login even if profile fetch fails
        }

        // Fetch permissions for member users
        if (user && user.user_type === "member" && user.id) {
          try {
            yield call(getUserPermissionsModule, {
              payload: { userId: user.id },
              callbackSuccess: () => {},
              callbackError: (error: any) => {
                console.warn("Failed to load user permissions in AutoLogin:", error);
              },
            });
          } catch (error) {
            console.warn("Error fetching user permissions in AutoLogin:", error);
          }
        }

        // Call success callback with the full response data
        action &&
          action.callbackSuccess &&
          action.callbackSuccess(resp.data.message || "Login successful", responseData);
      } else {
        action && action.callbackError && action.callbackError("Token or user missing in response");
      }
    } else {
      action && action.callbackError && action.callbackError(resp.data?.message || "Login failed");
    }
  } catch (e: any) {
    const errorMessage = e?.data?.message || e?.message || "Auto login failed";
    action && action.callbackError && action.callbackError(errorMessage);
  }
}

export function* deleteUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.DELETE_USER, action.payload, true);
}

export function* verify2FA(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.VERIFY_2FA, data);

    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      const token = resp.data.data.token;
      const user = resp.data.data.user;
      const rememberMe = data.rememberMe || false;

      if (token && user) {
        // Always store token in localStorage to support multiple tabs
        // This works with redux-persist which uses localStorage by default
        localStorage.setItem(STORAGE, token);

        // Handle Remember Me functionality - save email/password preferences
        if (rememberMe) {
          // Save email and rememberMe flag for future logins
          localStorage.setItem("DR-JOBS-REMEMBER-EMAIL", user.email || data.email);
          localStorage.setItem("DR-JOBS-REMEMBER-ME", "true");
        } else {
          // Clear any previously saved credentials
          localStorage.removeItem("DR-JOBS-REMEMBER-EMAIL");
          localStorage.removeItem("DR-JOBS-REMEMBER-ME");
        }

        // Dispatch Redux action to update authentication state
        yield put({
          type: ACTIONS.USER.LOGIN,
          payload: {
            user: user,
            token: token,
          },
        });

        // Fetch permissions for member users
        if (user.user_type === "member" && user.id) {
          try {
            yield call(getUserPermissionsModule, {
              payload: { userId: user.id },
              callbackSuccess: () => {},
              callbackError: (error: any) => {
                console.warn("Failed to load user permissions:", error);
              },
            });
          } catch (error) {
            console.warn("Error fetching user permissions:", error);
          }
        }

        // Call success callback
        action && action.callbackSuccess && action.callbackSuccess(resp.data);
      } else {
        action && action.callbackError && action.callbackError("Token or user missing");
      }
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* logoutUser(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.USER.LOGOUT, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      // Clear token from localStorage
      localStorage.removeItem(STORAGE);

      // Keep remember me data if user wants to be remembered
      // Only clear if this is a manual logout, not an auto-logout due to expired session
      if (action.clearRememberMe !== false) {
        localStorage.removeItem("DR-JOBS-REMEMBER-EMAIL");
        localStorage.removeItem("DR-JOBS-REMEMBER-ME");
      }

      // Clear the info plan bar dismissed flag so it appears again on fresh login
      localStorage.removeItem("infoPlanBarDismissed");

      yield put({
        type: ACTIONS.USER.LOGOUT,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateUserProfile(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.UPDATE_PROFILE, action.payload, true);
}

export function* companyUploadLogo(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.COMPANY_UPLOAD_LOGO, action.payload, true);
}

export function* getUserProfile(action: any): any {
  const yieldPuts = [{ type: ACTIONS.USER.ME }]; //, payload: "user"
  yield call(sagaFunction, action, CallApi.GET, API_URL.USER.DETAILS, action.payload, true, yieldPuts);
}

export function* updateDisplayName(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.UPDATE_DISPLAY_NAME, action.payload, true);
}

export function* checkValidToken(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.USER.CHECK_VALID_TOKEN, action.payload, true);
}

export function* getRegistrationFieldsData(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.USER.REGISTRATION_FIELDS + "/" + action.payload.gameId,
    null,
    true
  );
}

export function* saveNotification(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.SAVE_NOTIFICATION, action.payload, true);
}

export function* verifyEmail(action: any): any {
  try {
    const token = action.payload.token;
    const resp = yield call(CallApi.GET, API_URL.USER.VERIFY_EMAIL + "?token=" + token);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* resendVerification(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.USER.RESEND_VERIFICATION, action.payload);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateTwoFactorAuth(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.UPDATE_TWO_FACTOR_AUTH, action.payload, true);
}

export function* getUserPermissionsModule(action: any): any {
  try {
    const userId = action.payload.userId;
    const resp = yield call(CallApi.GET, API_URL.USERS_MANAGEMENT.GET_USER_PERMISSIONS(userId));

    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      // Store permissions in Redux with correct structure
      yield put({
        type: ACTIONS.USER.SET_PERMISSIONS,
        payload: {
          permissions: resp.data.data.permissions || [],
          member_id: resp.data.data.member_id,
          member_name: resp.data.data.member_name,
          member_email: resp.data.data.member_email,
          role_id: resp.data.data.role_id,
          role_name: resp.data.data.role_name,
        },
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* addCompanyBillingInfo(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.ADD_COMPANY_BILLING_INFO, action.payload, true);
}

export function* getCompanyBillingInfo(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.USER.GET_COMPANY_BILLING_INFO, null, true);
}

export function* getMyActivity(action: any): any {
  const params = action.payload || {};
  //yield call(sagaFunction, action, CallApi.GET, API_URL.USER.MY_ACTIVITY, params, true);

  try {
    const resp = yield call(CallApi.GET, API_URL.USER.MY_ACTIVITY, params, true);
    console.log("getMyActivity response:", resp);

    if (resp.status >= 200 && resp.status < 300 && resp?.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data?.message || "Error");
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data.message : e);
  }
}

export function* getAllUsersActivity(action: any): any {
  const params = action.payload || {};

  try {
    const resp = yield call(CallApi.GET, API_URL.USER.ALL_USERS_ACTIVITY, params, true);
    console.log("getAllUsersActivity response:", resp);

    if (resp.status >= 200 && resp.status < 300 && resp?.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data?.message || "Error");
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data.message : e);
  }
}

export function* deleteAccount(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USER.DELETE_ACCOUNT, {}, true);
}

export function* getUserData(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.USER.USER_DATA, {}, true);
    console.log("getUserData response:", resp);

    if (resp.status >= 200 && resp.status < 300 && resp?.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data?.message || "Error");
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data.message : e);
  }
}

export function* getNotifications(action: any): any {
  try {
    const params = action.payload || {};
    const resp = yield call(CallApi.GET, API_URL.USER.NOTIFICATIONS, params, true);
    console.log("getNotifications response:", resp);

    if (resp.status >= 200 && resp.status < 300 && resp?.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data?.message || "Error");
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data.message : e);
  }
}
